import React, { useState, useEffect } from 'react';
import Radio from 'v3/components/Radio';
import { Col, Row } from 'react-bootstrap';
import api, { cooperplaceApi } from 'services/api';
import Modal from 'v3/components/Modal';
import Select from 'v3/components/Select';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import { useUser } from '../context';

function AddShippingCompany({ isOpen, onClose }) {
  const user = useUser();
  const [shippingCompany, setShippingCompany] = useState();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [headquarter, setHeadquarter] = useState(false);

  useEffect(() => {
    if (user?.data?.shipping_companies?.length === 0) {
      setHeadquarter(true);
    }
  }, [user?.data?.shipping_companies]);

  const getShippingCompanies = () => (
    Array.isArray(user?.data?.shipping_companies)
      ? user.data.shipping_companies
      : []
  );

  async function fetchShippingCompanies(inputValue) {
    if (inputValue.length > 3) {
      const response = await api.get(`persons/shipping-company?search=${inputValue}`);
      return response.data;
    }
    return false;
  }

  const closeSubmit = () => {
    setError();
    setShippingCompany();
    onClose();
  };

  function handleAddShipper() {
    const shippingCompanies = getShippingCompanies();

    let updatedList;

    if (headquarter) {
      updatedList = [
        ...shippingCompanies.map((sc) => ({
          ...sc,
          pivot: {
            ...sc.pivot,
            is_headquarter: false,
          },
        })),
        {
          ...shippingCompany,
          pivot: {
            is_headquarter: true,
          },
        },
      ];
    } else {
      updatedList = [
        ...shippingCompanies,
        {
          ...shippingCompany,
          pivot: {
            is_headquarter: false,
          },
        },
      ];
    }

    user.setData({
      ...user.data,
      shipping_companies: updatedList,
    });

    closeSubmit();
  }

  async function handleAttachShipper() {
    try {
      setLoading(true);

      await cooperplaceApi.post(`user/add-shipping-company/${user.data.id}`, {
        shippingCompanyId: shippingCompany.id,
        is_headquarter: headquarter,
      });

      let updatedList;
      const shippingCompanies = getShippingCompanies();

      if (headquarter) {
        updatedList = [
          ...shippingCompanies.map((sc) => ({
            ...sc,
            pivot: {
              ...sc.pivot,
              is_headquarter: false,
            },
          })),
          {
            ...shippingCompany,
            pivot: {
              is_headquarter: true,
            },
          },
        ];
      } else {
        updatedList = [
          ...shippingCompanies,
          {
            ...shippingCompany,
            pivot: {
              is_headquarter: false,
            },
          },
        ];
      }

      user.setData({
        ...user.data,
        shipping_companies: updatedList,
      });

      user.showSnackbar('Transportadora vinculada', { type: 'success' });

      closeSubmit();
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao adicionar transportadora';
      user.showSnackbar(message, { type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  function handleAdd() {
    const shippingCompanies = getShippingCompanies();

    if (user.data.id) {
      handleAttachShipper();
    } else {
      if (
        shippingCompanies.find(item => item.id === shippingCompany.id)
      ) {
        setError('Essa transportadora já está cadastrada');
        return;
      }
      handleAddShipper();
    }
  }
  return (
    <>
      <Modal
        show={isOpen}
        onHide={closeSubmit}
        size="lg"
        heading={
          <Text color="dark" type="header">
            Transportadora
          </Text>
        }
        body={
          <Row>
            <Col xs={12} className="d-flex flex-column align-items-center">
              <Select.Async
                className="mt-3"
                label={
                  <Text type="label" weight="500">
                    Transportadora
                  </Text>
                }
                onSearch={(search) => fetchShippingCompanies(search)}
                value={shippingCompany}
                getOptionLabel={(option) => {
                  const label = `${option.social_name} - ${option.cgccpf}`;
                  return label;
                }}
                getOptionValue={(option) => option.id}
                onChange={(value) => {
                  setShippingCompany(value);
                }}
                error={error}
              />
            </Col>
            {
              user.data?.shipping_companies?.length === 0 ? null : (
                <Col xs={12} className="mt-3">
                  <Radio.Group
                    label="Tornar essa transportadora matriz"
                    onChange={({ target }) => setHeadquarter(Number(target.value) === 1)}
                    value={headquarter ? 1 : 0}
                    horizontal
                  >
                    <Radio value={1}>
                      <Text color="dark" type="label">
                        Sim
                      </Text>
                    </Radio>
                    <Radio value={0}>
                      <Text color="dark" type="label">
                        Não
                      </Text>
                    </Radio>
                  </Radio.Group>
                </Col>
              )
            }
            <Col className="d-flex justify-content-center">
              <Button
                onClick={handleAdd}
                className="my-2"
                disabled={!shippingCompany}
                loading={loading}
              >
                <Text type="regular" weight="500" color="white">
                  Adicionar
                </Text>
              </Button>
            </Col>
          </Row>
        }
      />
    </>
  );
}

export default AddShippingCompany;
